import { createContext, useContext, useState } from 'react';

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('lang') || 'es'; } catch { return 'es'; }
  });

  const toggleLang = () => {
    setLang(prev => {
      const next = prev === 'es' ? 'en' : 'es';
      try { localStorage.setItem('lang', next); } catch { /* noop */ }
      return next;
    });
  };

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within LangProvider');
  return ctx;
};
